import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import queryString from 'query-string';
import { useDispatch, useSelector } from 'react-redux';
import history from '@history';
import { alertSelect, clearAlertDialogPack, closeAlertDialog } from 'app/store/alertDialogSlice';

export default function GlobalAlertDialog() {
  const { open, dialogPack } = useSelector(alertSelect);
  const [dialogInfo, setDialogInfo] = React.useState();
  const dispatch = useDispatch();
  const handleClose = React.useCallback(() => {
    dispatch(closeAlertDialog());
    // for backHandler
    if (queryString.parse(history.location.search).openDialog) {
      history.go(-1);
    }
  }, [dispatch]);

  const closeFirst = (callBack) => () => {
    callBack();
    handleClose();
  };
  const afterCloseHandler = () => setDialogInfo(undefined);

  React.useEffect(() => {
    if (dialogPack.length && !dialogInfo) {
      setDialogInfo({ ...dialogPack[0] });
      dispatch(clearAlertDialogPack());
      // for backHandler
      if (!queryString.parse(history.location.search).openDialog) {
        const params = queryString.parse(history.location.search);
        history.push(`?${queryString.stringify({ ...params, openDialog: 1 })}`);
      }
    } else if (dialogPack.length && dialogInfo && open) {
      handleClose();
    }
  }, [dialogPack, dialogInfo, open, dispatch, handleClose]);

  return (
    <Dialog
      open={!!dialogInfo && open}
      onClose={dialogInfo?.cancelable ? handleClose : undefined}
      scroll="body"
      key={dialogInfo?.key}
      maxWidth={dialogInfo?.maxWidth || 'xs'}
      fullWidth
      TransitionProps={{ onExited: afterCloseHandler }}
    >
      <DialogTitle>{dialogInfo?.title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{dialogInfo?.body}</DialogContentText>
      </DialogContent>
      <DialogActions>
        {dialogInfo?.cancelable && (
          <Button
            color="error"
            onClick={dialogInfo?.onCancel ? closeFirst(dialogInfo.onCancel) : handleClose}
          >
            {dialogInfo?.cancelText || (dialogInfo?.onOk ? 'لغو' : 'قبول')}
          </Button>
        )}

        {dialogInfo?.onOk && (
          <Button variant="contained" onClick={closeFirst(dialogInfo.onOk)}>
            {dialogInfo.okText || 'قبول'}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}
